import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs';
import { RaygunService } from 'src/app/raygun/raygun.service';
import { errorTypeMap } from '../../mappers';

import { ErrorNotificationService } from '../../services/error-notification.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private raygunService = inject(RaygunService);
  private errorNotificationService = inject(ErrorNotificationService);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: unknown) => {
        if (err instanceof HttpErrorResponse) {
          const serverErrortext = this.logRaygunError(err, request);
          const error: string = serverErrortext ? serverErrortext : err.message || err.error.message || err.statusText;
          if (err && err.url && err.url.indexOf('/createNetSuite') >= 0) {
            return throwError(() => new Error(error));
          }

          if (shouldReturnOriginalError(request)) {
            const errorResponse = new HttpErrorResponse({
              error: this.getHttpErrorResponseErrorMap(err),
              headers: err.headers,
              status: err.status,
              statusText: err.statusText,
              url: err.url,
            });

            return throwError(() => errorResponse);
          }

          setTimeout(() => {
            // wait for everything to complete.
            const errorMap = this.getErrorMap(err);

            const currentUrl = request.url.replace(/\/?[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g, '/*');

            if ((currentUrl.includes('profileType/individual/command/StartToActive') || currentUrl.includes('profile/*/benefitAccount/*/command/StartToEnrolled')) && err.status === 0 && err.message.includes('Unknown Error')) {
              return;
            }

            if (typeof errorMap === 'object') {
              Object.keys(this.getErrorMap(err)).forEach((errorKey) => {
                this.errorNotificationService.notifyErrorOthers({ status: err.status, type: errorTypeMap[errorKey] });
              });
            } else {
              this.errorNotificationService.notifyErrorOthers({ status: 500 });
            }
          }, 500);

          return throwError(() => new Error(error));
        } else {
          return throwError(() => err);
        }
      })
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private logRaygunError(err: any, request: HttpRequest<any>): string {
    const serverErrorObj = this.getErrorMap(err);
    let serverErrortext: string;
    let token: string;
    if (request.headers && request.headers) {
      token = request.headers.get('authorization');
    }
    if (serverErrorObj && serverErrorObj instanceof Object && Object.keys(serverErrorObj).length > 0 && err.status !== 0) {
      serverErrortext = Object.keys(serverErrorObj)[0] + ': ' + Object.values(serverErrorObj)[0];
      this.raygunService.logError(serverErrortext, { err, token });
    } else {
      this.raygunService.logError({ err, token });
    }
    return serverErrortext;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private getErrorMap(err: Record<string, any>): Record<string, string> {
    return err?.error?.error || err?.error?.errors || err.error;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private getHttpErrorResponseErrorMap(err: Record<string, any>): Record<string, string> {
    return {
      error: err?.error?.error || err?.error?.errors || err.error,
      message: err?.error?.message || err?.message,
    };
  }
}

function shouldReturnOriginalError(request: HttpRequest<unknown>) {
  const paths = ['/bcsRenewalClient/', '/security/v1/forgotPassword', '/security/v1/confirmForgotPassword'];
  return paths.some((path) => request.url.includes(path)) && request.method === 'PUT';
}
